import { Close, VStack, useUnleash } from '@/package';
import { VDrawer, VFlex } from '@/package';
import type { Project } from '@/type';

import { TaskCreateForm } from '.';

export const TaskCreateFormDrawer = ({
  visibleTaskCreationDrawer,
  hideTaskCreationDrawer,
  setTabValue,
  projectDetailData,
}: {
  visibleTaskCreationDrawer: boolean;
  hideTaskCreationDrawer: () => void;
  setTabValue: () => void;
  projectDetailData: Project;
}) => {
  const { getVariant } = useUnleash();
  const isTaskIntervalReadOnly = getVariant(
    'vuex.sapporo.taskIntervalReadOnly',
  )?.feature_enabled;
  const taskConfigReadOnly = getVariant('vuex.sapporo.taskConfigReadonly');
  const isTaskConfigReadOnly = taskConfigReadOnly?.feature_enabled;

  return (
    <VDrawer
      visible={visibleTaskCreationDrawer}
      onUpdateVisible={visible => !visible && hideTaskCreationDrawer()}
      position="right"
    >
      <VFlex className="h-full w-[1036px] bg-white px-8 pt-[21px]">
        <VStack className="w-full" gap={1}>
          <VFlex items={'center'} justify="between">
            <div className="text-headline-sm text-gray-600">Create task</div>
            <Close
              role="button"
              onClick={() => {
                hideTaskCreationDrawer();
              }}
              className="h-6 w-6"
            />
          </VFlex>
          <TaskCreateForm
            readOnlyField={{
              classConfidence: isTaskConfigReadOnly,
              distance: isTaskConfigReadOnly,
              workFrameInterval: isTaskIntervalReadOnly,
            }}
            onCancel={() => hideTaskCreationDrawer()}
            onTaskCreated={() => {
              hideTaskCreationDrawer();
              setTabValue();
            }}
            projectData={projectDetailData}
          />
        </VStack>
      </VFlex>
    </VDrawer>
  );
};
